import { assert } from '../../../utils'

import { ConnectwareError, ConnectwareErrorType, type StatusType } from '../../../domain'

import { mapToStatusType } from '..'

export const mapRSTResourceStatusViewId = (resource: Readonly<{ id: string }>): string => resource.id

export const mapRSTResourceStatusViewCurrentStatusType = (state: Readonly<{ current: string }>): StatusType => mapToStatusType(state.current)

export const createNonCountMapper =
    <V, T>(mapper: (value: Exclude<V, number>) => T): ((maybeCount: V) => T) =>
    (maybeCount) => {
        assert(
            typeof maybeCount !== 'number',
            new ConnectwareError(ConnectwareErrorType.MAPPING_ERROR, 'Server did not respond with service specific deviations count')
        )
        return mapper(maybeCount as Exclude<V, number>)
    }
